import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@rq-ratings/pro-light-svg-icons'
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const ServiceLockedWarning: React.FC = () => {
  return (
    <>
      {' '}
      <OverlayTrigger
        overlay={
          <Tooltip>
            "General Enquiries" is default service when we refer to somebody who
            is not yet in RQ
          </Tooltip>
        }
      >
        <FontAwesomeIcon icon={faCircleInfo} style={{ fontSize: '12px' }} />
      </OverlayTrigger>
    </>
  )
}

export default ServiceLockedWarning
